var React = require('react');

function UnternehmenOnlineArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.52904 68.0354C0.160046 69.4001 0.156546 71.6161 1.52122 72.9851C2.88589 74.3541 5.10197 74.3576 6.47096 72.9929L1.52904 68.0354ZM417 70.5142L402.51 32.7867L377.082 64.1994L417 70.5142ZM6.47096 72.9929C48.3911 31.205 119.633 9.81706 193.215 7.27211C266.752 4.7287 341.679 21.0443 390.583 53.6139L394.463 47.7877C343.963 14.155 267.441 -2.29932 192.973 0.276296C118.549 2.85037 45.232 24.4703 1.52904 68.0354L6.47096 72.9929Z","fill":"#4D6888"}));
}

UnternehmenOnlineArrowRight.defaultProps = {"width":"417","height":"75","viewBox":"0 0 417 75","fill":"none"};

module.exports = UnternehmenOnlineArrowRight;

UnternehmenOnlineArrowRight.default = UnternehmenOnlineArrowRight;
